var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashHDashIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.505127 6.85342C0.505127 5.8356 0.505127 5.32669 0.710872 4.87936C0.916618 4.43202 1.30301 4.10083 2.0758 3.43844L2.82543 2.79589C4.22224 1.59863 4.92064 1 5.75256 1C6.58449 1 7.28289 1.59863 8.67969 2.79589L9.42933 3.43844C10.2021 4.10083 10.5885 4.43202 10.7943 4.87936C11 5.32669 11 5.8356 11 6.85342V10.0322C11 11.4457 11 12.1524 10.5609 12.5916C10.1217 13.0307 9.41499 13.0307 8.00146 13.0307H3.50366C2.09014 13.0307 1.38338 13.0307 0.944252 12.5916C0.505127 12.1524 0.505127 11.4457 0.505127 10.0322V6.85342Z",
    stroke: "#222222",
    strokeWidth: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.62671 13.031V9.5332C7.62671 8.98092 7.17899 8.5332 6.62671 8.5332H4.87854C4.32626 8.5332 3.87854 8.98092 3.87854 9.5332V13.031",
    stroke: "#222222",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashHDashIcon);
export default __webpack_public_path__ + "static/media/dash-h-dash-icon.c474e13f2fa2e773ce445985d56d86e0.svg";
export { ForwardRef as ReactComponent };